// @flow
import { all } from 'redux-saga/effects';
import appMenuSaga from './appMenu/saga';
import authSaga from './auth/saga';
import layoutSaga from './layout/saga';

export default function* rootSaga(getState) {
    yield all([authSaga(), layoutSaga(), appMenuSaga()]);
}
